import React from 'react';
import posed from 'react-pose';
import { subscribe } from './alertStore';

const Box = posed.div({
    visible: { opacity: 1 },
    hidden: { opacity: 0 }
});

export default class Jumbotron extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            alert: {
                show: false,
                type: '',
                text: ''
            }
        }
    }

    componentDidMount() {
        subscribe((alert) => {
            this.alert(alert)
        })
    }

    hideAlert = () => {
        this.setState({ alert: { show: false } });
    }

    alert = (alert) => {
        this.setState({
            alert: {
                show: true,
                type: alert.type,
                text: alert.text
            }
        });

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        if (['warning', 'danger'].filter(type => alert.type.indexOf(type) == -1).length == 0) {
            this.timeout = setTimeout(() => {
                this.hideAlert();
                this.timeout = null;
            }, 2000);
        }
    }

    render() {
        return <div className="jumbotron jumbotron-fluid mb-0 pb-1">
            <div className="p-2">
                <h1 className="display-4">{this.props.title}</h1>
                <p className="lead">{this.props.text}</p>
                <Box pose={this.state.alert.show ? 'visible' : 'hidden'}>
                    <div className={`alert ${this.state.alert.type} ${this.state.alert.show ? "" : ""}`} onClick={this.hideAlert}>
                        {this.state.alert.text}
                    </div>
                </Box>
            </div>
        </div >
    }
}